// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"299":"05fefcac","488":"818c422d"}[chunkId] + ".chunk.js";
};